import { ApolloClient, NormalizedCacheObject } from '@apollo/client'
import { Environment } from 'config/environment'

import axiosInterceptors from './axiosInterceptors'
import brokenVersionChecker from './brokenVersionChecker'
import buildUrl from './buildUrl'
import datadog from './datadog'
import fonts from './fonts'
import metrics from './metrics'
import mobxRest from './mobxRest'
import pdfjs from './pdfjs'
import sentry from './sentry'
import svg from './svg'

type Initializer = (environment: Environment) => void

type DataInitializer = (
  environment: Environment,
  apolloClient: ApolloClient<NormalizedCacheObject>
) => void

export const initializers: Initializer[] = [
  buildUrl,
  brokenVersionChecker,
  datadog,
  metrics,
  mobxRest,
  sentry,
  svg,
  pdfjs,
  fonts,
]

export const dataInitializers: DataInitializer[] = [axiosInterceptors]
